import { render, staticRenderFns } from "./FormDesignEdit.vue?vue&type=template&id=6e630616&scoped=true&"
import script from "./FormDesignEdit.vue?vue&type=script&lang=js&"
export * from "./FormDesignEdit.vue?vue&type=script&lang=js&"
import style0 from "./FormDesignEdit.vue?vue&type=style&index=0&id=6e630616&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e630616",
  null
  
)

export default component.exports